module.exports = __webpack_public_path__ + "img/brifecase.764bf2e5.svg";